import Body from "./body"
import Footer from "./footer"
import Header from "./header"
import Outer from "./outer"
import SubHeader from "./sub-header"

export default {Body, Footer, Header, Outer, SubHeader}
